import { FC } from 'react';
import { Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { styles } from './styles';

const SKELETON_CARDS_COUNT = 2;

export const RoomsResultsSkeleton: FC = () => {
    const { t } = useTranslation();

    // Skeletons are purely visual, so announce the search to screen readers too
    return (
        <Box css={styles.resultsSection} role="status" aria-label={t('rooms_page_searching')}>
            <Box css={styles.resultsHeader}>
                <Skeleton variant="text" css={styles.skeletonTitle} />
            </Box>
            <Box css={styles.resultsContainer}>
                {Array.from({ length: SKELETON_CARDS_COUNT }, (_, index) => (
                    <Skeleton key={index} variant="rectangular" css={styles.skeletonCard} />
                ))}
            </Box>
        </Box>
    );
};
